import { Fragment, useState } from "react";
import moment from "moment";
import CardDetails from "./CardDetails";
import CardLimit from "./CardLimits";
// import viewAllImg from "../../assets/images/icons/arrow-right.svg";
import { Env } from "../../enviroment/environment";
import CHDSendMoney from "./CHDSendMoney";
import useWindowDimensions from "../../helpers/WindowWidth";
import SearchGridCardTransactions from "./SearchGridCardTransactions";
import KapedVirtualAssistant from "./KapedVirtualAssistant";
import {useSelector } from "react-redux";
import cardholdercardsObj from "../../services/cardholder-cards.service";
import ModelPopup from "../../helpers/ModelPopup";
import BoLoader from "../../helpers/BoLoader";
import DialoguePopup from "../../helpers/DialoguePopup";
import RefreshToken from "../../helpers/RefreshToken";
const API_URL = Env.CardsApiUrl;

const CHDashBoard = (props) => {
  const { height, width } = useWindowDimensions();
  const { user: currentUser } = useSelector(state => state.auth);
  var setpermission = localStorage.getItem("activeInactiveSendmoney");

  const [modalShow3DS, setModalShow3DS] = useState(false);
  const [codesList, setCodesList] = useState([]);
  const [boloader, setBoLoader] = useState(false);
  const [modalShowDialouge, setModalShowDialouge] = useState(false);
  const [dlgHeading, setDlgHeading] = useState("");
  const [dlgBody, setDlgBody] = useState("");

  const showError = (msg) => {
    setDlgHeading("Error");
    setDlgBody(msg || "Unable to fetch 3DS codes.");
    setModalShowDialouge(true);
  };

  const open3DSCodes = () => {
    setBoLoader(true);
    cardholdercardsObj
      .getVerificationCodesNkt(currentUser?.user?.UserId)
      .then((resp) => {
        setBoLoader(false);
        if (resp?.data?.success) {
          const list = Array.isArray(resp?.data?.payload) ? resp.data.payload : [];
          setCodesList(list.slice(0, 3));
          setModalShow3DS(true);
        } else {
          showError(resp?.data?.message);
        }
      })
      .catch((error) => {
        setBoLoader(false);
        const status = error?.response?.status;
        (async () => {
          const refreshed = await RefreshToken(status);
          if (refreshed) {
            open3DSCodes();
          } else {
            showError(error?.response?.data?.message);
          }
        })();
      });
  };

  return (
    <Fragment>
      <div className="col-xl-6 col-lg-8 col-md-12 bo-main-content">
        <h3>
          Your Cards<span className="bo-badge bo-badge-large">1</span>
        </h3>
        <div className="row mt-20">
          {(currentUser?.user?.ClientId ===35) ?(<div className="col-xl-6 col-md-6 col-sm-6 mb-20">
            <CardDetails cht="Y" />
            {currentUser?.user?.IssuerName === "IssuerCap-NKT" && (
              <div className="text-left mt-3">
                <button type="button" className="btn btn-large" onClick={open3DSCodes}>
                  3DS Code
                </button>
              </div>
            )}
          </div>):(<div className="col-xl-6 col-md-6 col-sm-6 mb-20">
            <CardDetails cht="Y" />
            {currentUser?.user?.IssuerName === "IssuerCap-NKT" && (
              <div className="text-left mt-3">
                <button type="button" className="btn btn-large" onClick={open3DSCodes}>
                  3DS Code
                </button>
              </div>
            )}
          </div>)}

          {currentUser?.user?.IssuerName !== "IssuerTG" && <CardLimit />}
        </div>

        {/* for mobile */}
        <div className="row">
        {props?.clientsid!=35 && (
<Fragment>
{setpermission!=="true" && (width <= 991 && <><CHDSendMoney isPermission={props?.sendmoneypermission}/> 
</>

)} 
</Fragment>
          )} 
        
        </div>

        <SearchGridCardTransactions
          placeholdervalue="Search Card Holder Transactions"
          headersdata={[
            "DATE",
            "MERCHANT NAME",
            "STATUS",
            // "CURRENCY",
            "AMOUNT",
            // "REF #",
            "VIEW",
          ]}
          screenname="cardholdertransactions"
        />
      </div>
    
         {
        props?.clientid!==35 ? (
          <Fragment>
             {setpermission!=="true" && (width > 991 && <CHDSendMoney  isPermission={props?.sendmoneypermission}/>
            )} 

            </Fragment>
        ):  
        (props?.clientid===35) ?(
          <div className="col-xl-3 col-lg-4 col-lg-0 bo-right-sidebar">
        <div className="bo-right-sidebar-wrap">
       
          <div className="row align-items-center"></div>
          {/* <iframe  src="https://app.thimble.com/home?brokerid=PKAX8P5EB&widget_source=embed" style={{marginLeft:'-22px', height:'800px', width:"400px", borderRadius:"8px", marginTop:"-50px"}}>
          </iframe> */}
          </div>
          <div id="body">
          <KapedVirtualAssistant/>
      
    </div>
          </div>
          
        ):("")

      }

      <BoLoader loading={boloader} />

      <ModelPopup
        show={modalShow3DS}
        onHide={() => setModalShow3DS(false)}
        modelheading="3D Secure Codes"
        showheader="true"
        className="smallPopup issueCardSmall"
        dialogClassName="modal-dialog modal-dialog-centered mwidth-42"
        backdrop="static"
        keyboard={false}
        modelbody={
          <Fragment>
            {codesList.length === 0 ? (
              <p className="text-center">No verification codes available.</p>
            ) : (
              <ul className="list-group">
                {codesList.map((item, idx) => (
                  <li
                    key={idx}
                    className="d-flex justify-content-between align-items-center p-2 border-bottom"
                  >
                    <strong>{item.code}</strong>
                    <span>{moment(item.date).format("DD MMM YYYY, HH:mm")}</span>
                  </li>
                ))}
              </ul>
            )}
          </Fragment>
        }
      />

      <DialoguePopup
        show={modalShowDialouge}
        onHide={() => setModalShowDialouge(false)}
        modelheading={dlgHeading}
        modelbody={dlgBody}
        modelicon="icon-error"
      />

    </Fragment>
  );
};

export default CHDashBoard;
